var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9167 16.3125V10.2708C16.9167 6.56125 14.935 3.45583 11.4792 2.63417V1.8125C11.4792 0.809583 10.6696 0 9.66667 0C8.66375 0 7.85417 0.809583 7.85417 1.8125V2.63417C4.38625 3.45583 2.41667 6.54917 2.41667 10.2708V16.3125L0 18.7292V19.9375H19.3333V18.7292L16.9167 16.3125ZM10.875 16.3125H8.45833V13.8958H10.875V16.3125ZM10.875 11.4792H8.45833V6.64583H10.875V11.4792ZM9.66667 23.5625C10.9958 23.5625 12.0833 22.475 12.0833 21.1458H7.25C7.25 22.475 8.32542 23.5625 9.66667 23.5625Z",
    fill: "#0871B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertInfo);
export default __webpack_public_path__ + "static/media/alert-info.dcfab3f81643dc80ee8b6c2c5ba0c83a.svg";
export { ForwardRef as ReactComponent };